import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "cars99_token";

export const http = axios.create({ baseURL: API });
http.interceptors.request.use((cfg) => {
  const tk = localStorage.getItem(TOKEN_KEY);
  if (tk) cfg.headers.Authorization = `Bearer ${tk}`;
  return cfg;
});

export const photoUrl = (path) => (path ? `${API}/files/${path}` : null);

export const PHONE = "+393938169377";
export const PHONE_DISPLAY = "+39 393 816 9377";
export const EMAIL = "showroom@cars99.it";
export const ADDRESS = "Via Cividina, 99 – 33100 Udine (UD)";
export const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=Via+Cividina+99+33100+Udine";

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Errore. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const trField = (car, key, lang) => car?.[`${key}_i18n`]?.[lang] || car?.[key] || "";

export const carTitle = (c) => [c?.make, c?.model].filter(Boolean).join(" ") || "—";

export const fmtPrice = (n, locale) =>
  new Intl.NumberFormat(locale, { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);

export const fmtNum = (n, locale) => new Intl.NumberFormat(locale).format(n);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};
